define('CustomerCategory.Categories.Model', [
    'Categories.Model',
    'CustomerCategory.Utils',
    'Profile.Model',
    'underscore'
], function CustomerCategoryCategoriesModel(
    CategoriesModelModule,
    CustomerCategoryUtils,
    ProfileModelModule,
    _
) {
    'use strict';

    var CategoriesModel = CategoriesModelModule.CategoriesModel || CategoriesModelModule;
    var ProfileModel = ProfileModelModule.ProfileModel || ProfileModelModule;
    var originalParse = CategoriesModel.prototype.parse;

    function reduceCategories(memo, categories, profileCategory) {
        var categoriesGroup = SC.ENVIRONMENT.published.commerceCategoriesGroup || [];
        _.each(categories, function eachCategories(category) {
            var subCategories;
            var categoryGroup = categoriesGroup && categoriesGroup[category.internalid];

            if (CustomerCategoryUtils.isCategoryVisible(
                categoryGroup,
                profileCategory,
                SC.ENVIRONMENT.currentHostString,
                !!(categoriesGroup && categoriesGroup.length)
            )) {
                subCategories = [];
                reduceCategories(subCategories, category.categories || [], profileCategory);
                category.categories = subCategories;

                memo.push(category);
            }
        });

        return memo;
    }

    _.extend(CategoriesModel.prototype, {
        parse: function parse(response) {
            var parsedResponse = originalParse ? originalParse.call(this, response) : response;
            var profile = ProfileModel.getInstance();
            var profileCustomFields = profile && profile.get('customfields');
            var webCategory = profileCustomFields && profileCustomFields.length && _.findWhere(profileCustomFields, { name: 'custentity6' });
            var customerCategory = (webCategory && webCategory.value) || '1';
            var subcategories = [];
            var siblings = [];
            var categoriesGroup = SC.ENVIRONMENT.published.commerceCategoriesGroup || [];
            if (categoriesGroup && categoriesGroup.length && parsedResponse && parsedResponse.internalid) {
                reduceCategories(subcategories, parsedResponse.categories || [], customerCategory);
                reduceCategories(siblings, parsedResponse.siblings || [], customerCategory);
                parsedResponse.categories = subcategories;
                parsedResponse.siblings = siblings;
            }

            return parsedResponse;
        }
    });
});
